export default __webpack_public_path__ + "static/media/Logo_MT.dc0d6ed4.png";